import React from 'react';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onPageChange }) => {
  const { t } = usePageTranslation('panel', 'UserRolesManagement');

  if (totalPages <= 1) return null;

  return (
    <div className="mt-4 flex items-center justify-between">
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="rounded-lg border border-[#2a3a62] bg-[#0a132b] px-4 py-2 text-sm text-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#0d1b3a] transition-colors"
      >
        {t('pagination.previous')}
      </button>
      <span className="text-sm text-slate-400">
        {t('pagination.page')} {page} / {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="rounded-lg border border-[#2a3a62] bg-[#0a132b] px-4 py-2 text-sm text-slate-200 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#0d1b3a] transition-colors"
      >
        {t('pagination.next')}
      </button>
    </div>
  );
};

export default Pagination;
